/// <amd-module name="Feed/IvyPromote/Components/IvyPromotePanel" />
import * as React from "react";
import { connect } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";

import { VssComponent } from "VSS/Platform/Layout";

import { Dropdown } from "VSSUI/Dropdown";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { Panel } from "VSSUI/Panel";
import { Spinner } from "VSSUI/Spinner";

import * as Resources from "Feed/Common/Resources";
import { FeedHubActions } from "Feed/Core/Redux/FeedHub";
import { IPackageVersion } from "Feed/Core/Types";
import { IIvyPromoteAwareState, IvyPromoteActions, IvyPromoteModule } from "Feed/IvyPromote/Redux/IvyPromote";

const Actions = {
    closePanel: FeedHubActions.hideIvyPromote,
    loadPackageStatus: IvyPromoteActions.getPackageStatus,
    savePackageStatus: IvyPromoteActions.savePackageStatus
};

interface IIvyPromotePanelProps {
    isSaving: boolean;
    statusesList: string[];
    packageStatus: string;
    ivyPackage: IPackageVersion;
    errorMessage?: string;
}

interface IIvyPromotePanelState {
    status: string;
}

class IvyPromotePanel extends React.Component<IIvyPromotePanelProps & typeof Actions, IIvyPromotePanelState> {
    public componentDidMount() {
        this.props.loadPackageStatus(this.props.ivyPackage);
        this.setState({ status: this.props.packageStatus || "" });
    }

    public render(): JSX.Element {
        return (
            <Panel
                titleProps={{ text: "Promote package" }}
                description={"Promote this package to a status. Add statuses for your feed using the REST-API."}
                onDismiss={this.props.closePanel}
                footerButtonProps={[
                    { text: "Cancel", onClick: this.props.closePanel },
                    {
                        text: "Promote",
                        primary: true,
                        onClick: () => this.props.savePackageStatus(this.props.ivyPackage, this.state.status),
                        type: "submit"
                    }
                ]}
                overlayContent={this.props.isSaving ? <Spinner label={Resources.Overlay_Saving} /> : undefined}
            >
                <div>
                    {this.props.errorMessage && (
                        <MessageCard severity={MessageCardSeverity.Error}>{this.props.errorMessage}</MessageCard>
                    )}
                    <p>Current status: {this.props.packageStatus || " not set yet"}</p>
                    <div className="flex-row" style={{ margin: "16px", alignItems: "center_horizontal" }}>
                        <Dropdown
                            placeholder="Select a Status"
                            items={this.props.statusesList}
                            onSelect={(event, item) => this.setState({ status: item.text || "" })}
                        />
                    </div>
                </div>
            </Panel>
        );
    }
}

function mapStateToProps(state: IIvyPromoteAwareState): IIvyPromotePanelProps {
    return {
        isSaving: state.ivyPromoteState.isSaving,
        statusesList: state.ivyPromoteState.statuses,
        packageStatus: state.ivyPromoteState.currentStatus,
        ivyPackage: state.ui.showIvyPromote!,
        errorMessage: state.ivyPromoteState.errorMessage
    };
}

const ConnectedIvyPromotePanel = connect(mapStateToProps, Actions)(IvyPromotePanel);

class DynamicIvyPromotePanel extends React.PureComponent {
    public render() {
        return (
            <DynamicModuleLoader modules={IvyPromoteModule}>
                <ConnectedIvyPromotePanel />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("ms.feed.feed-ivypromote.ivy-promote-panel", DynamicIvyPromotePanel);
